module.exports = __webpack_public_path__ + "img/recharge_info.0c6cf4ca.png";